import { render, staticRenderFns } from "./food_log.vue?vue&type=template&id=9d46d1ec&scoped=true&lang=html&"
import script from "./food_log.vue?vue&type=script&lang=js&"
export * from "./food_log.vue?vue&type=script&lang=js&"
import style0 from "./food_log.vue?vue&type=style&index=0&id=9d46d1ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d46d1ec",
  null
  
)

export default component.exports